import React from 'react';
import { _T, C } from '../../shared/theme';
import { GROWTH_CATEGORIES } from '../../features/goals/constants';

function RadarChart({levels, size=220}) {
  const cats = GROWTH_CATEGORIES;
  const n = cats.length;
  const cx=size/2, cy=size/2, r=size*0.38;
  const angle = (i) => (i/n)*2*Math.PI - Math.PI/2;
  const pt = (i, val, max=5) => ({
    x: cx + r*(val/max)*Math.cos(angle(i)),
    y: cy + r*(val/max)*Math.sin(angle(i)),
  });

  // Grid rings
  const rings = [1,2,3,4,5].map(ring => {
    const pts = cats.map((_,i)=>pt(i,ring));
    return pts.map((p,i)=>`${i===0?"M":"L"}${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(" ")+"Z";
  });

  // Data polygon
  const dataPts = cats.map((c,i)=>pt(i, levels[c.id]||1));
  const dataPath = dataPts.map((p,i)=>`${i===0?"M":"L"}${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(" ")+"Z";

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{overflow:"visible"}}>
      {/* Grid spokes */}
      {cats.map((_,i)=>{
        const p=pt(i,5);
        return <line key={i} x1={cx} y1={cy} x2={p.x} y2={p.y} stroke={`${C.silver}22`} strokeWidth="1"/>;
      })}
      {/* Grid rings */}
      {rings.map((d,i)=>(
        <path key={i} d={d} fill="none" stroke={`${C.silver}18`} strokeWidth="1"/>
      ))}
      {/* Data fill */}
      <path d={dataPath} fill={`${_T.accent}20`} stroke={_T.accent} strokeWidth="2"/>
      {/* Data points */}
      {dataPts.map((p,i)=>(
        <circle key={i} cx={p.x} cy={p.y} r="4" fill={GROWTH_CATEGORIES[i].color} stroke={_T.bg} strokeWidth="2"/>
      ))}
      {/* Labels */}
      {cats.map((c,i)=>{
        const lp=pt(i,5.8);
        return (
          <g key={i}>
            <text x={lp.x} y={lp.y-4} textAnchor="middle" fill={c.color} fontSize="16">{c.icon}</text>
            <text x={lp.x} y={lp.y+10} textAnchor="middle" fill={C.silver} fontSize="7" fontFamily="Inter">{`Lv${levels[c.id]||1}`}</text>
          </g>
        );
      })}
    </svg>
  );
}

export default RadarChart;
